<template>
  <div class="shop">
    <h2 class="uk-margin-bottom">Магазин подарков</h2>
    <back></back>
    <div class="game scores">
      <Products />
      <div v-if="user.property.cart">
        <hr>
        <Cart :items="user.property.cart" />
        <Order :items="user.property.cart" />
      </div>
    </div>
  </div>
</template>

<script>
import Products from "./Products";
import Cart from "./Cart";
import Order from "./Order";
import { mapGetters } from 'vuex'

export default {
  name: "index",
  components: {
    Products, Cart, Order
  },
  data() {
    return {
      order: ''
    }
  },
  computed: {
    ...mapGetters({
      user: 'user'
    })
  }
}
</script>